import { ActionsUnion, createAction } from 'spw-redux/types';
import { ILibrary } from './types';

export const START_DOWNLOAD = 'library/START_DOWNLOAD';
export const FETCH_PROJECT_LIBRARY = 'library/FETCH_PROJECT_LIBRARY';
export const FETCH_PROJECT_LIBRARY_SUCCESS =
  'library/FETCH_PROJECT_LIBRARY_SUCCESS';
export const SET_LOADING_PROJECT_LIBRARY =
  'library/SET_LOADING_PROJECT_LIBRARY';
export const SELECT_ASSET = 'library/SELECT_ASSET';
export const SELECT_BUILDING = 'library/SELECT_BUILDING';
export const TOGGLE_LIBRARY = 'library/TOGGLE_LIBRARY';
export const TOGGLE_LIGHTBOX = 'library/TOGGLE_LIGHTBOX';
export const FETCH_BUILDING_NOTES_SPREADSHEET =
  'library/FETCH_BUILDING_NOTES_SPREADSHEET';
export const FETCH_BUILDING_NOTES_SPREADSHEET_FAILED =
  'library/FETCH_BUILDING_NOTES_SPREADSHEET_FAILED';
export const FETCH_BUILDING_NOTES_SPREADSHEET_SUCCESS =
  'library/FETCH_BUILDING_NOTES_SPREADSHEET_SUCCESS';
export const SWITCH_VIEW = 'library/SWITCH_VIEW';

export const startDownload = (isDownloading: boolean) =>
  createAction(START_DOWNLOAD, { isDownloading });

export const fetchProjectLibrary = (
  projectId: number,
  buildingId: number,
  floorId: number
) => createAction(FETCH_PROJECT_LIBRARY, { projectId, buildingId, floorId });

export const fetchProjectLibrarySuccess = (projectLibrary: ILibrary) =>
  createAction(FETCH_PROJECT_LIBRARY_SUCCESS, { projectLibrary });

export const setLoadingLibrary = (isLoading: boolean) =>
  createAction(SET_LOADING_PROJECT_LIBRARY, { isLoading });

export const selectAsset = (assetId: number) =>
  createAction(SELECT_ASSET, { assetId });

export const selectBuilding = (buildingId: number, floorId: number) =>
  createAction(SELECT_BUILDING, { buildingId, floorId });

export const switchView = (view: boolean) =>
  createAction(SWITCH_VIEW, { view });

export const toggleLibrary = (open: boolean) =>
  createAction(TOGGLE_LIBRARY, { open });

export const toggleLightbox = (open: boolean) =>
  createAction(TOGGLE_LIGHTBOX, { open });

export const fetchBuildingNotesSpreadsheet = (buildingId: number) =>
  createAction(FETCH_BUILDING_NOTES_SPREADSHEET, { buildingId });

export const fetchBuildingNotesSpreadsheetSuccess = () =>
  createAction(FETCH_BUILDING_NOTES_SPREADSHEET_SUCCESS);

export const fetchBuildingNotesSpreadsheetFailed = () =>
  createAction(FETCH_BUILDING_NOTES_SPREADSHEET_FAILED);

export const actions = {
  fetchProjectLibrary,
  fetchProjectLibrarySuccess,
  setLoadingLibrary,
  selectAsset,
  selectBuilding,
  startDownload,
  switchView,
  toggleLibrary,
  toggleLightbox,
  fetchBuildingNotesSpreadsheet,
  fetchBuildingNotesSpreadsheetSuccess,
  fetchBuildingNotesSpreadsheetFailed,
};

export type Actions = ActionsUnion<typeof actions>;
